import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import LazyImage from '../components/LazyImage';

function Home() {
  const [testimonials, setTestimonials] = useState([]);
  const [settings, setSettings] = useState({});
  const [menuFiles, setMenuFiles] = useState([]);
  const [menuCarouselIndex, setMenuCarouselIndex] = useState(0);
  const [selectedMenuFile, setSelectedMenuFile] = useState(null);
  
  const itemsPerView = 2;
  
  useEffect(() => {
    // Load menu files
    apiService.getMenuFiles()
      .then(response => setMenuFiles(response.data.menu_files))
      .catch(error => console.error('Error loading menu files:', error));
  }, []);
  
  const maxIndex = Math.max(0, menuFiles.length - itemsPerView);
  
  const nextMenu = () => {
    setMenuCarouselIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };
  
  const prevMenu = () => {
    setMenuCarouselIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  useEffect(() => {
    // Load testimonials
    apiService.getTestimonials(true)
      .then(response => setTestimonials(response.data.testimonials))
      .catch(error => console.error('Error loading testimonials:', error));

    // Load settings
    apiService.getSettings()
      .then(response => setSettings(response.data.settings))
      .catch(error => console.error('Error loading settings:', error));
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: 'url(/images/food-1.jpg)'
        }}
      >
        <video 
          autoPlay
          loop
          muted
          playsInline
          className="hero-video"
          onError={(e) => {
            console.error('Hero video failed to load, using background image fallback');
            e.target.style.display = 'none';
          }}
        >
          <source src="/yamas-main-video.mp4" type="video/mp4" />
        </video>
        <div className="hero-content">
          <h1 className="hero-title">A TASTE OF GREECE</h1>
          {/* <p className="hero-subtitle">YAMAS COFFEE | KITCHEN</p> */}
          <a
            href="https://eatapp.co/reserve/yamas-nairobi?source=iframe"
            onClick={(e) => {
              if (typeof window.eatapp_ShowWidget === 'function') {
                e.preventDefault();
                window.eatapp_ShowWidget.apply(e.currentTarget, [e]);
              }
            }}
            className="btn-primary"
          >
            Dine with Us
          </a>
        </div>
      </section>

      {/* Greek Fling Section */}
      <section 
        className="section section-light"
        style={{
          backgroundImage: 'url(/yamas pattern.png)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
          backgroundPosition: '0 0'
        }}
      >
        <div className="container">
          <div className="two-column">
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', gridTemplateRows: 'auto auto'}}>
              <img 
                src="/images/a-greek-fling.png"
                alt="Greek Food" 
                className="content-image"
                style={{width: '575px', height: '500px', objectFit: 'fill', borderRadius: '4px', gridColumn: '1', gridRow: '1'}}
              />
              {/* <img 
                src="/images/food-2.jpg"
                alt="Greek Food" 
                className="content-image"
                style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px', gridColumn: '2 / 3', gridRow: '1 / 3'}}
              /> */}
            </div>
            <div>
              <h2 className="section-title">
                A <span style={{color: 'var(--primary-blue)'}}>GREEK</span> FLING
              </h2>
              <p className="section-text">
                Welcome to Yamas, a little taste of Greece in the heart of Nairobi. At Yamas, we celebrate the rich flavors of Greece with dishes crafted from the finest local farm-sourced ingredients, ensuring unprecedented freshness in every bite. Our commitment to quality and top-notch service sets us apart, offering an elevated dining experience that captures the essence of Greek hospitality.
              </p>
              <br />
              <a
                href="/reserve"
                className="btn-primary"
              >
                Reserve Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Flavors of Greece Section */}
      <section 
        className="section section-light"
        style={{
          backgroundColor: '#ffffff'
        }}
      >
        <div className="container">
          <div className="two-column">
            <div>
              <h2 className="section-title" style={{color: '#000'}}>
                FLAVORS<br/>
                OF <span style={{color: 'var(--primary-blue)'}}>GREECE</span>
              </h2>
              <p className="section-text" style={{color: '#333'}}>
                Indulge in authentic flavors, impeccable craftsmanship, and a warm, inviting ambiance because at Yamas, every meal is a celebration.
              </p>
            </div>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'center'}}>
              <img 
                src="/images/flavors-of-greece.png"
                alt="Greek Cheese" 
                className="content-image"
                style={{
                  width: '745px',
                  height: '625px',
                  objectFit: 'fill',
                  borderRadius: '4px'
                }}
              />
              {/* <img 
                src="/images/blue-plate.jpg"
                alt="Greek Blue Plate" 
                className="content-image"
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'cover',
                  borderRadius: '4px'
                }}
              /> */}
            </div>
          </div>
        </div>
      </section>

      {/* Dining Experience Videos */}
      <section className="section section-light">
        <div className="container">
          <div className="three-column" style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px'}}>
            <video 
              src="/video1.mp4"
              autoPlay
              loop
              controls
              muted
              playsInline
              className="portrait-video"
            />
            <video 
              src="/video2.mp4"
              autoPlay
              loop
              controls
              muted
              playsInline
              className="portrait-video"
            />
            <video 
              src="/video3.mp4"
              autoPlay
              loop
              controls
              muted
              playsInline
              className="portrait-video"
            />
          </div>
        </div>
      </section>

      {/* Menu Preview Carousel */}
      {menuFiles.length > 0 && (
        <section 
          className="section section-dark"
          style={{
            backgroundImage: 'url(/images/table.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container menu-preview">
            <div className="menu-carousel">
              <button className="carousel-btn carousel-btn-left" onClick={prevMenu} aria-label="Previous menu" disabled={menuFiles.length <= itemsPerView}>
                ‹
              </button>
              <div className="menu-carousel-container">
                {menuFiles.slice(menuCarouselIndex, menuCarouselIndex + itemsPerView).map((file, idx) => (
                  <div key={file.id} className="menu-carousel-item" onClick={() => setSelectedMenuFile(file)} style={{cursor: 'pointer'}}>
                    {file.file_type === 'image' ? (
                      <img 
                        src={file.file_path} 
                        alt={file.file_name} 
                        className="menu-image content-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentElement.innerHTML = '<div style="width: 100%; height: 600px; background: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999;">Image not found</div>';
                        }}
                      />
                    ) : (
                      <iframe 
                        src={file.file_path} 
                        title={file.file_name}
                        className="menu-image content-image"
                        style={{minHeight: '600px', border: 'none'}}
                      />
                    )}
                  </div>
                ))}
              </div>
              <button className="carousel-btn carousel-btn-right" onClick={nextMenu} aria-label="Next menu" disabled={menuFiles.length <= itemsPerView}>
                ›
              </button>
            </div>
          </div>
        </section>
      )}

      {/* Love for Yamas - Testimonials */}
      <section className="section section-blue">
        <div className="container">
          <h2 className="section-title" style={{textAlign: 'center', marginBottom: '60px'}}>
            LOVE FOR YAMAS
          </h2>
          <div className="three-column">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-title-wrapper">
                  <img 
                    src="/images/quotation-mark.png" 
                    alt="" 
                    className="testimonial-quote-mark"
                  />
                  <p className="testimonial-title">{testimonial.location || ''}</p>
                </div>
                <p className="testimonial-quote">{testimonial.content}</p>
                <p className="testimonial-author">- {testimonial.customer_name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* See You Soon - Contact */}
      <section className="section section-light">
        <div className="container">
          <div className="two-column">
            <div>
              <img 
                src="/images/table.jpg"
                alt="Restaurant Table" 
                className="content-image"
                style={{width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '4px'}}
              />
            </div>
            <div className="contact-info">
              <h2 className="section-title">
                SEE YOU <span style={{color: 'var(--primary-blue)'}}>SOON</span>
              </h2>
              <div className="contact-item">
                <p className="contact-label">PHONE NUMBER</p>
                <p className="contact-value">
                  <a href={`tel:${settings.site_phone || '+254742432358'}`}>
                    {settings.site_phone || '+254 742 432 358'}
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <p className="contact-label">EMAIL ADDRESS</p>
                <p className="contact-value">
                  <a href={`mailto:${settings.site_email || 'hello@yamas.co.ke'}`}>
                    {settings.site_email || 'hello@yamas.co.ke'}
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <p className="contact-label">RESTAURANT</p>
                <p className="contact-value">{settings.site_address || 'Westgate Shopping Mall, Ground Floor'}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Menu File Modal/Popup */}
      {selectedMenuFile && (
        <div className="menu-modal-overlay" onClick={() => setSelectedMenuFile(null)}>
          <div className="menu-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="menu-modal-close" onClick={() => setSelectedMenuFile(null)}>×</button>
            {selectedMenuFile.file_type === 'image' ? (
              <img 
                src={selectedMenuFile.file_path} 
                alt={selectedMenuFile.file_name} 
                className="menu-modal-image" 
              />
            ) : (
              <iframe 
                src={selectedMenuFile.file_path} 
                title={selectedMenuFile.file_name}
                className="menu-modal-iframe"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
